export default __webpack_public_path__ + "static/media/nigel2.c6d5dbd9.JPEG";